import { createFileRoute } from "@tanstack/react-router"
import { Activity } from "modules/campaigns/components/Detail/Activity"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { CampaignLogKindEnum, GetConversationsResponsesSortBy } from "schema"
import { z } from "zod"

const ActivityFilterBySchema = z.object({
  goalId: z.string().optional(),
  customerId: z.string().optional(),
  kind: z.enum(CampaignLogKindEnum).optional(),
})

const SearchSchema = z.object({
  ...PaginationSearchSchema.shape,
  ...SearchQuerySchema.shape,
  ...GetConversationsResponsesSortBy.shape.sortBy.unwrap().shape,
  section: z.string().optional(),
  filterBy: ActivityFilterBySchema.optional(),
})

export const Route = createFileRoute("/_base/_auth/campaigns/$id/activity")({
  validateSearch: SearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { section } = Route.useSearch()
  return <Activity section={section} />
}
